module.exports = "/images/blog-date.png?03a3e05a1d51eed63fee1e0541eab574";